<template>
  <div class="msg-btn">
    <input
      :disabled="comments.videoBarrageOpen === 2"
      maxlength="50"
      ref="input"
      @keydown.enter="send"
      v-model="msg"
      @input="onInput"
      :placeholder="comments.liveBarrageOpen === 2 ? '该活动关闭了视频弹幕' : '我来发一条视频弹幕'"
    />
    <i @click="showVideoDanmuSet = true" class="iconfont icondanmu-shezhi"></i>
    <div @click="send" class="send-btn">发送</div>
    <!-- 视频弹幕设置 -->
    <van-action-sheet
      :close-on-click-overlay="false"
      :value="showVideoDanmuSet"
      title="弹幕设置"
      @cancel="handleCancel"
    >
      <div class="videoDanmu-content">
        <div class="content-item">
          <div class="title">弹幕列表</div>
          <van-radio-group @change="toggleDanmuType" v-model="videoDanmuSet.type" direction="horizontal">
            <van-radio name="1">观看全部</van-radio>
            <!-- <van-radio name="2">只看标记</van-radio> -->
          </van-radio-group>
        </div>
        <div class="content-item">
          <div class="title">视频弹幕</div>
          <van-switch @change="toggleDanmuOpen" size="20px" :value="videoDanmuSet.isOpen" />
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '',
      showVideoDanmuSet: false
    }
  },
  computed: {
    videoDanmuSet() {
      return this.$store.state.activePlay.videoDanmuSet
    },
    comments() {
      return this.$store.state.activePlay.comments
    }
  },
  methods: {
    onInput() {
      const reg2 = /([\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF])|(\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6])|(\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0])/g
      this.msg = this.msg.replace(reg2, '')
    },
    handleCancel() {
      this.showVideoDanmuSet = false
    },
    send() {
      this.msg = this.msg.trim()
      if (!this.msg) return
      this.$emit('on-send', this.msg)
      this.msg = ''
    },
    toggleDanmuOpen(isOpen) {
      this.$store.commit('setVideoDanmuSet', {isOpen})

      if (!this.srceenDom) {
        this.srceenDom = document.querySelector('.videoBullet')
      }
      if (isOpen) {
        this.srceenDom.style.opacity = 1
      } else {
        this.srceenDom.style.opacity = 0
      }
    },
    toggleDanmuType(type) {
      this.$store.commit('setVideoDanmuSet', {type})
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-btn {
  width: 100%;
  height: 60px;
  background: #fbfcfd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.04);
}
input {
  flex: 1;
  flex-shrink: 2;
  outline: none;
  border: none;
  background: #eef0f3;
  border-radius: 20px;
  height: 34px;
  padding: 0 10px;
  margin-right: 10px;
  &::placeholder {
    color: #c0c4cc;
  }
}

.send-btn {
  width: 60px;
  text-align: center;
  color: #fff;
  background-color: #3b8bff;
  border-radius: 8px;
  font-size: 14px;
  padding: 10px 0;
}

.icondanmu-shezhi {
  font-size: 30px;
  margin-right: 10px;
  color: #c0c4cc;
}
.videoDanmu-content {
  padding: 20px 16px;
  .content-item + .content-item {
    margin-top: 30px;
  }
  .content-item {
    display: flex;
    align-items: center;
    .title {
      margin-right: 20px;
    }
  }
}
</style>
